import { Box, Divider, Grid, Paper, Typography } from '@mui/material'
import css from './styles.module.css'
import useSafeInfo from '@/hooks/useSafeInfo'
import EthHashInfo from '../EthHashInfo'
import { useState } from 'react'
import usePopulatedEOASRequest from '@/hooks/super-chain/usePopulatedEOASRequest'
import type { Address } from 'viem'
import RemovePopulateModal from '@/components/superChain/RemovePopulateModal'
export const ADD_EOA_INITIAL_STATE = {
  open: false,
  currentAmountOfPopulatedOwners: 0,
}
export const REMOVE_POPULATE_INITIAL_STATE = {
  open: false,
  address: '',
}
const SuperChainEOAS = () => {
  const { safe } = useSafeInfo()
  const [removePopulateContext, setRemovePopulateContext] = useState(REMOVE_POPULATE_INITIAL_STATE)
  const {
    data: populatedOwners,
    loading: populatedOwnersLoading,
    updateQuery,
  } = usePopulatedEOASRequest(safe.address.value as Address)
  return (
    <div className={css.container}>
      <Typography fontWeight={600} fontSize={16} marginBottom={1}>
        Account
      </Typography>
      <Paper
        style={{
          height: '100%',
        }}
      >
        <Grid container gap={2} height="100%" alignItems="center" justifyContent="center" flexDirection="column">
          <Box height="100%" width="100%" sx={{ backgroundColor: '#FCFCFD' }}>
            <Box
              padding="16px"
              paddingY="12px"
              alignItems="center"
              display="flex"
              justifyContent="space-between"
              width="100%"
              flexDirection="row"
            >
              <Typography fontSize={16} fontWeight="600">
                Connected Wallets
              </Typography>
            </Box>
            <Divider sx={{ borderBottomWidth: '2px', borderColor: '#B3AFAB' }} />
            <Box
              p={2}
              gap={2}
              alignItems="center"
              display="flex"
              justifyContent="space-between"
              width="100%"
              flexDirection="column"
            >
              {safe.owners.map((owner, key) => (
                <EthHashInfo
                  avatarSize={30}
                  key={key}
                  address={owner.value}
                  showCopyButton
                  prefix=""
                  shortAddress={false}
                  showName={false}
                  hasExplorer
                />
              ))}
              {populatedOwners?.ownerPopulateds?.map((owner: { newOwner: string }, key: number) => (
                <EthHashInfo
                  isPopulated={true}
                  avatarSize={30}
                  setRemovePopulateContext={setRemovePopulateContext}
                  key={key}
                  shortAddressSize={2}
                  address={owner.newOwner}
                  showCopyButton
                  prefix=""
                  shortAddress={false}
                  showName={false}
                  hasExplorer
                />
              ))}
            </Box>
          </Box>
        </Grid>
      </Paper>
      <RemovePopulateModal
        updateQuery={updateQuery}
        context={removePopulateContext}
        onClose={() => setRemovePopulateContext(REMOVE_POPULATE_INITIAL_STATE)}
      />
    </div>
  )
}

export default SuperChainEOAS
